import React from "react";
import { rng } from '../../../../../../../amorg-common';
import { Button } from "../../../../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../../../../designSystem/button/ButtonRow";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { LoadingPageOverlay } from "../../../../../../../designSystem/LoadingPageOverlay";
import { MessageCard } from "../../../../../../../designSystem/Message";
import { PageHeader } from "../../../../../../../designSystem/PageHeader";
import { ActionPlanListView } from "../../../../../../../amorg-common/DTOs/ActionPlanListView";
import { getActionPlansByActivityId, createActionPlan } from "../../../../../../../api/actionPlanClientApi";
import { SurveyActionPlanStatusSection } from "../../_components/SurveyActionPlanStatusSection";
import { WorkplaceAssessmentComponentProps } from "../../_components/WorkplaceAssessmentComponentProps";
import { ActionPlanListingPageSectionTable } from "../../../../../../_components/activities/ActionPlanListingPageSectionTable";

type State = {
    actionPlansLoading: boolean,
    actionPlans: ActionPlanListView[]
};

type ActionPlansPanelListingProps = WorkplaceAssessmentComponentProps &
{
    onActionPlanSelected: (actionPlanId: string) => void;
};

export function ActionPlansPanelListing (props: ActionPlansPanelListingProps): JSX.Element
{

    const [state, setState] = React.useState<State>(
        {
            actionPlansLoading: true,
            actionPlans: []
        }
    );

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            await loadData();
        };
        getData();
    }, []);

    async function loadData ()
    {
        const actionPlans = await getActionPlansByActivityId(props.activity.id);

        setState({
            actionPlansLoading: false,
            actionPlans
        });
    }

    async function handleClickCreateActionPlan ()
    {
        const result = await createActionPlan(rng.getRandomId(), props.activity.id, 'WPA');
        if (result.isSuccess)
        {
            await loadData();
        }
    }

    return (
        <>
            {state.actionPlansLoading &&
                <LoadingPageOverlay loading={true} />
            }

            <PageHeader
                headerText="APV handleplaner" headerIcon="construction" headerStyle="secondary-gray" />


            {(props.survey === null || props.survey.segmentations.length === 0) &&
                <>
                    {state.actionPlans.length === 0 &&
                        <MessageCard variant="info">
                            Der er ikke oprettet nogen handleplaner.<br />Tilføj en ny handleplan for at komme i gang.
                        </MessageCard>
                    }
                </>
            }

            {props.survey && props.survey.segmentations.length > 0 &&

                <SurveyActionPlanStatusSection 
                    headerText="Status på oprettelse af handleplaner" 
                    survey={props.survey} 
                    surveyReport={props.surveyReport} 
                    actionPlans={state.actionPlans} />
            }

            <Flex flexDirection="column" gap={16}>

                <ActionPlanListingPageSectionTable
                    items={state.actionPlans }
                    noContentText="Ingen handleplaner oprettet"
                    onClick={props.onActionPlanSelected}
                />

                <ButtonRow variant="stretched">
                    <Button 
                        variant='light'
                        size={"32px"}
                        onClick={handleClickCreateActionPlan}
                        text={"Opret handleplan"}
                        icon="actions_plus"
                    />
                </ButtonRow>
            </Flex>
        </>
    );
}